/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
// import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';


import { StatusConst } from '@constants/general';

class AddEvaluatorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: '',
      url: '',
      estatus: 1,
      btnSubmitLoading: false,
      errors: []
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onHidden, onAction } = this.props
    const { nombre, url, justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    const data = {
      nombre,
      url
    }
    onAction(data, justification)
    return onHidden()
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { nombre, url, justification } = this.state
    let errors = {}
    if (!nombre) errors = { ...errors, 'nombre': `${t('Nombre')} ${t('es requerido')}`}
    if (!url) errors = { ...errors, 'url': `${t('URL')} ${t('es requerido')}`}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }


  render () {
    const { t, onHidden } = this.props
    const { nombre, url, estatus, errors, btnSubmitLoading } = this.state
    
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const children = (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Nombre')}
            </label>
            <InputText
              name="nombre"
              type="text"
              value={nombre}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`nombre`),
              })}
            />
            {getFormErrorMessage(`nombre`)}
          </div>
          <div className="p-col-12 p-field ">
            <label className="p-text-bold">
              {t('URL')}
            </label>
            <InputText
              name="url"
              type="text"
              value={url}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`url`),
              })}
            />
            {getFormErrorMessage(`url`)}
          </div>
          <div className='p-col-12'>
            <label className="">{t('Justificación del cambio')}</label>
            <InputTextarea
              name="justification"
              onChange={(e) =>
                this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
              }
              rows={5}
              cols={30}
              className={classNames({
                'p-invalid': isFormFieldValid(`justification`),
              })}
            />
          {getFormErrorMessage(`justification`)}
          </div>
          {/* <div className="p-col-12 p-field">
            <label className="p-text-bold">
              {t('Estatus')}
            </label>
            <div className="p-field-radiobutton p-mt-2">
              <RadioButton
                inputId="estatus"
                name="estatus"
                value={StatusConst.IS_ACTIVE}
                onChange={this.onChange}
                checked={estatus === StatusConst.IS_ACTIVE}
              />
              <label className="p-pl-2 p-pr-3">{t('Activo')}</label>
              <RadioButton
                inputId="estatus"
                name="estatus"
                value={StatusConst.IS_SUSPENDED}
                onChange={this.onChange}
                checked={estatus === StatusConst.IS_SUSPENDED}
              />
              <label className="p-pl-2">{t('Suspendido')}</label>
            </div>
          </div> */}
          <div className="p-col-12 p-dialog-footer custom">
            {/* <div className="p-d-flex p-jc-end"> */}
            <Button
              label={t('Cerrar')}
              type="buttpn"
              className="p-button-secondary p-button-text p-button-raised"
              onClick={onHidden}
            />
            <Button
              label={t('Guardar')}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
          {/* </div> */}
        </div>
      </form>
    )

    return (
      <Dialog
        header={t('Nuevo Evaluador')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
});

export default compose(withTranslation(), connect(mapStateToProps, null))(AddEvaluatorModal)

